import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export const HEADINGS = {
  centres: 'Centres',
  westfieldProducts: 'Westfield Gift Cards',
  products: 'Products',
  westfieldServices: 'Westfield Services',
  topStores: 'Top Stores',
  brands: 'Brands',
  events: 'Events',
  offers: 'Offers',
  news: 'News',
  stories: 'Stories',
  nearbyStores: 'Other nearby stores',
  nearCentreStores: 'Other stores',
  productCollections: 'Curated Collections',
  emptySearchSuggestions: 'Popular Searches',
  otherStoresNearCentre: 'Other Stores near',
  noResult: ''
};

const getSegmentsToHeadings = headings => ({
  westfieldProducts: headings.westfieldProducts,
  retailers: headings.topStores,
  contentfulBrands: headings.brands,
  facetBrands: headings.brands,
  stores: headings.topStores,
  sites: headings.westfieldServices,
  services: headings.westfieldServices,
  offers: headings.offers,
  events: headings.events,
  news: headings.news,
  localStories: headings.stories,
  nationalStories: headings.stories,
  centres: headings.centres,
  onlineServices: headings.westfieldServices,
  nearCentreStores: headings.nearCentreStores,
  products: headings.products,
  productCollections: headings.productCollections,
  emptySearchSuggestions: headings.emptySearchSuggestions,
  productQuerySuggestions: headings.products
});

const headingsForCentre = (headings, centre) => {
  const centreHeadings = _objectSpread({}, headings);

  if (centre) {
    centreHeadings.nearCentreStores += " near ".concat(centre.title);
  }

  return centreHeadings;
};

export function makeHeadingInfo(centre) {
  const headings = headingsForCentre(HEADINGS, centre);
  const segmentToHeadings = getSegmentsToHeadings(headings);

  const getHeadingForSegment = segment => segmentToHeadings[segment];

  const headingsToDisplay = Object.values(headings);
  return {
    getHeadingForSegment,
    headingsToDisplay
  };
}